import React from 'react';
// import {
// 	Route,
// 	Link
// } from 'react-router-dom';
import './examples.scss';
import { Carousel } from 'antd';
// import ajax from '@/api/public';

class Resource extends React.Component{
	constructor (props) {
		super(props)
		this.state={

		}
	}
    componentDidMount (){
        document.getElementById('app').scrollIntoView(true)
    }
	render() {
		return(
			<div className='weidai'>
				<div className='common-head home-contain'>
					<a href='#/customer' className="mianbaoxie">客户案例</a> <i className='glyphicon glyphicon-toright'></i> <span>杭州佳丽摄影艺术有限公司</span>
				</div>
				<div className='common-title' style={{marginBottom: '24px'}}>杭州佳丽摄影艺术有限公司</div>
				<div className='home-contain' style={{padding: '0 108px'}}>
					<div className='group--left'>
						<span>推广产品名称：佳丽婚纱摄影</span>
						<span>推广主题文案：佳丽摄影中国十大杰出摄影品牌</span>
						<span>推广平台：360搜索展示广告</span>
						<span className='special'>数据效果：曝光量25w、点击率4.5%、用户增长350个、转化</span>
						<span>成本200元/个   （时间周期：2018年1月1日-2018年8月31日）</span>
						<span>客户需求：转化提升5% &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 效果数据：咨询量上升15%</span>
					</div>
					<div className='group--right'>
						<div className='pull-right' style={{textAlign: 'right'}}>
							<img src={`${process.env.PUBLIC_URL}/images/jiali.png`} />
						</div>
						<div className='common-title text-center pull-right' style={{width: '415px', marginTop: '12px'}}>效果展示</div>
					</div>
				</div>
				<div className='home-contain text-contain' style={{padding: '0 108px 50px 108px'}}>
					<span className='special'>投放方案：</span>
					<span className='special'>在360上投放搜索广告，利用360PC搜索优势，拓展大量婚纱摄影通用词，自由品牌词，同行竞品词，疑问词等，制作精美的广告图片，醒目的广告内容与</span>
					<span>优惠信息将品牌理念快速传递给目标客群，从而实现业绩攀升。</span>
					<span className='special'>投放总结：</span>
					<span className='special'>推广到达页及时根据当月活动修改文案图片，做到创意与到达页内容高度一致，网民到达页面之后能直观看到自己想看的内容，活动信息醒目，婚纱照样</span>
					<span>片美观吸引度强，网站内沟通工具全天有客服在线，其他微博，微信相关关注方式都在网站内体现，全方位覆盖。</span>
				  <span>客户评价：广告位置清晰醒目，后台强大便于数据分析，服务团队专业细致，愿意长期合作。</span>
				</div>
			</div>
		)
	}
}
export default Resource;



// WEBPACK FOOTER //
// ./src/components/examples/jiali.jsx